import { render, staticRenderFns } from "./RdbDataSource.vue?vue&type=template&id=bb63c99a&"
import script from "./RdbDataSource.vue?vue&type=script&lang=js&"
export * from "./RdbDataSource.vue?vue&type=script&lang=js&"
import style0 from "./RdbDataSource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports